"use strict";
exports.__esModule = true;
exports.SvgDragHandle = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgDragHandle = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ "aria-hidden": "true", fill: "none", viewBox: "0 0 20 20" }, props),
    react_1["default"].createElement("rect", { x: 5, y: 1, width: 10, height: 2, rx: 1, fill: "currentColor" }),
    react_1["default"].createElement("rect", { x: 5, y: 5, width: 10, height: 2, rx: 1, fill: "currentColor" }),
    react_1["default"].createElement("rect", { x: 5, y: 9, width: 10, height: 2, rx: 1, fill: "currentColor" }),
    react_1["default"].createElement("rect", { x: 5, y: 13, width: 10, height: 2, rx: 1, fill: "currentColor" }),
    react_1["default"].createElement("rect", { x: 5, y: 17, width: 10, height: 2, rx: 1, fill: "currentColor" }))); };
//# sourceMappingURL=DragHandle.js.map